import { render, staticRenderFns } from "./icon-person.vue?vue&type=template&id=6818c548&"
import script from "./icon-person.vue?vue&type=script&lang=js&"
export * from "./icon-person.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Third Coast Creative/repos/MidwestBeltone.Iframes/MidwestBeltone.Iframes.Web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6818c548')) {
      api.createRecord('6818c548', component.options)
    } else {
      api.reload('6818c548', component.options)
    }
    module.hot.accept("./icon-person.vue?vue&type=template&id=6818c548&", function () {
      api.rerender('6818c548', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Frontend/vue/icons/icon-person.vue"
export default component.exports